export default __webpack_public_path__ + "static/media/pause.4ab1e1b3.svg";